<template>
  <div class="content">
    <detail-item :iconurl="public_path + '/static/images/software_number_icon.svg'" :title="'设备编号'" :value="dev.soft_sn"></detail-item>
    <detail-item :iconurl="public_path + '/static/images/driving_city_icon.svg'" :title="'练车城市'" :value="dev.city_name"></detail-item>
    <detail-item :iconurl="public_path + '/static/images/coach_icon.svg'" :title="'所属教练'" :value="dev.coach_name"></detail-item>
    <detail-item :iconurl="public_path + '/static/images/coach_phone_icon.svg'" :title="'教练电话'" :value="dev.coach_mobile"></detail-item>
    <detail-item :iconurl="public_path + '/static/images/equipment_state_icon.svg'" :title="'设备状态'" :value="dev.state_cn"></detail-item>
    <detail-item :iconurl="public_path + '/static/images/time_icon.svg'" :title="'激活时间'" :value="dev.active_at"></detail-item>
    <!-- <detail-item :iconurl="public_path + '/static/images/time_icon.svg'" :title="'设备收入'" :value="dev.total_amount"></detail-item> -->
    <detail-item v-if="dev.disable_at" :iconurl="public_path + '/static/images/disable_time_icon.svg'" :title="'禁用时间'" :value="dev.disable_at"></detail-item>
    <detail-item v-if="dev.remark" :iconurl="public_path + '/static/images/remarks_icon.svg'" :title="'备注'" :value="dev.remark"></detail-item>
  </div>
</template>
<script>
import detailItem from '@/components/detail_item'
export default {
  data () {
    return {
      dev: {},
      public_path: process.env.PUBLICK_PATH
    }
  },
  components: {
    'detail-item': detailItem
  },
  mounted () {
    let dev = this.$route.params.dev
    this.dev = dev
    console.log(this.dev)
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  padding: .1rem .3rem 0 .3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentdetail/Equipmentdetail.vue